import AOS from "aos";
import "aos/dist/aos.css";

// Marks the nav link matching the current page as active — replaces the old
// per-page Handlebars `page` param, so navbar.html has no templating logic.
function highlightActiveNavLink() {
  const currentFile = window.location.pathname.split("/").pop() || "index.html";

  document.querySelectorAll(".navbar-nav .nav-link").forEach((link) => {
    const linkFile = link.getAttribute("href").split("/").pop();
    const isActive = linkFile === currentFile;

    link.classList.toggle("active", isActive);
    if (isActive) {
      link.setAttribute("aria-current", "page");
    } else {
      link.removeAttribute("aria-current");
    }
  });

  // Viewing a submenu page (e.g. blog.html under Media) also highlights its
  // parent link ("Media"), matching the design — the parent's own href
  // (media.html) never matches currentFile on its own.
  document.querySelectorAll(".menu-item-has-children").forEach((parent) => {
    const hasActiveChild = Array.from(parent.querySelectorAll(".sub-menu a")).some(
      (a) => a.getAttribute("href").split("/").pop() === currentFile
    );
    if (hasActiveChild) {
      const parentLink = parent.querySelector(":scope > .nav-link");
      if (parentLink) {
        parentLink.classList.add("active");
        parentLink.setAttribute("aria-current", "page");
      }
    }
  });
}

document.addEventListener("DOMContentLoaded", highlightActiveNavLink);

// Nav submenus (Business/Media, WordPress-style .menu-item-has-children /
// .sub-menu markup — see navbar.html): open on hover for real pointers via
// CSS alone (see .menu-item-has-children:hover in _components.scss). On
// touch devices there's no hover, so the dedicated arrow button next to
// each link toggles the submenu open on tap — the "Business"/"Media" link
// itself is untouched and always navigates normally on click/tap.
function closeAllSubmenus(except) {
  document.querySelectorAll(".sub-menu.show").forEach((menu) => {
    if (menu === except) return;
    menu.classList.remove("show");
    const toggle = menu.previousElementSibling;
    if (toggle && toggle.classList.contains("submenu-toggle")) {
      toggle.setAttribute("aria-expanded", "false");
    }
  });
}

document.querySelectorAll(".submenu-toggle").forEach((toggle) => {
  toggle.addEventListener("click", (event) => {
    event.preventDefault();
    const menu = toggle.nextElementSibling;
    const isOpen = menu.classList.toggle("show");
    toggle.setAttribute("aria-expanded", String(isOpen));
    closeAllSubmenus(isOpen ? menu : null);
  });
});

document.addEventListener("click", (event) => {
  if (!event.target.closest(".menu-item-has-children")) {
    closeAllSubmenus();
  }
});

AOS.init({
  duration: 1000,
  easing: "ease-out-cubic",
  offset: 80,
  once: false,
});

// Stat numbers (e.g. "200+ MW") count up from 0 every time they scroll into
// view. Triggered by IntersectionObserver directly rather than AOS, since
// some sections (manufacturing's stat rows) need the count-up with no
// visual fade/slide reveal at all — decoupling from AOS's data-aos/
// aos-animate means the counter works whether or not a section also opts
// into an AOS animation.
function animateStatNumber(el) {
  if (!el.dataset.statOriginal) {
    el.dataset.statOriginal = el.textContent.trim();
  }
  const original = el.dataset.statOriginal;
  const match = original.match(/^(\d+)(.*)$/);
  if (!match) return;

  const target = parseInt(match[1], 10);
  const suffix = match[2];
  const duration = 1200;
  const start = performance.now();
  // Guards against overlapping runs if the element re-enters view before a
  // previous count-up finishes — each tick checks it's still the latest.
  const token = (el._statToken = Symbol());

  function tick(now) {
    if (el._statToken !== token) return;

    const progress = Math.min((now - start) / duration, 1);
    const eased = 1 - Math.pow(1 - progress, 3);
    el.textContent = Math.round(target * eased) + suffix;

    if (progress < 1) {
      requestAnimationFrame(tick);
    } else {
      el.textContent = original;
    }
  }

  requestAnimationFrame(tick);
}

const statObserver = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        animateStatNumber(entry.target);
      }
    });
  },
  { threshold: 0.4 }
);

document.querySelectorAll(".stat-number").forEach((statNumber) => {
  statObserver.observe(statNumber);
});


// back-to-top button with circular progress indicator
document.addEventListener("DOMContentLoaded", function () {
    const backToTop = document.getElementById("backToTop");
    const progressCircle = document.querySelector(".progress-ring-progress");
    const radius = 30;
    const circumference = 2 * Math.PI * radius;
    progressCircle.style.strokeDasharray = circumference;
    progressCircle.style.strokeDashoffset = circumference;
    function updateBackToTop() {
        const scrollTop = window.scrollY;
        const documentHeight =
            document.documentElement.scrollHeight - window.innerHeight;
        if (scrollTop > 400) {
            backToTop.classList.add("show");
        } else {
            backToTop.classList.remove("show");
        }
        const scrollPercent =
            documentHeight > 0
                ? scrollTop / documentHeight
                : 0;
        const offset =
            circumference - (scrollPercent * circumference);
        progressCircle.style.strokeDashoffset = offset;
    }
    window.addEventListener("scroll", updateBackToTop);
    backToTop.addEventListener("click", function () {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    });
    updateBackToTop();
});